import { render, staticRenderFns } from "./AedesAegypti.vue?vue&type=template&id=3ea3782b&scoped=true"
import script from "./AedesAegypti.vue?vue&type=script&lang=js"
export * from "./AedesAegypti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea3782b",
  null
  
)

export default component.exports